import API from '@/api';
const User = API.get('User');

export default ({
  namespaced: true,
  
  state: {
    /* admin page users */
    users: [],
    pages: 1,
    user: null,
    displayName: '',
    /* form fields */
    name: '',
    image: '',
    category: '',
    supervisor: false,
    position: '',
    birthday: '',
    sss: '',
    philhealth: '',
    pagibig: '',
    email: '',
    phone: '',
    address: '',
    type: ''
  },
  
  getters: {
    /* admin page users */
    users: state => state.users,
    pages: state => state.pages,
    user: state => state.user,
    /* form fields */
    name: state => state.name,
    image: state => state.image,
    category: state => state.category,
    supervisor: state => state.supervisor,
    position: state => state.position,
    birthday: state => state.birthday,
    sss: state => state.sss,
    philhealth: state => state.philhealth,
    pagibig: state => state.pagibig,
    email: state => state.email,
    phone: state => state.phone,
    address: state => state.address,
    displayName: state => state.displayName,
    type: state => state.type
  },

  mutations: {
    /* admin page users */
    setUsers(state, {users, pages}) {
      state.users = users
      state.pages = pages
    },
    setCurrentUser(state, user) {
      state.user = user
    },
    setFields(state, data) {
      var type = data.user_type
      var profile = data[type]

      var types = [
        { type: 'doctor', category: 'Doctor' },
        { type: 'tma', category: 'TMA' },
        { type: 'admin', category: 'Admin' },
        { type: 'csr', category: 'CSR' },
      ]
      var index = types.findIndex(item => { return data[item.type] })

      // state.position = 'Pediatric'
      // state.sss = '123456789'
      // state.philhealth = '022500018635'
      // state.pagibig = '123458789112'
      state.email = data.email
      var name = ''
      var address = ''
      var phone = ''
      var birthday = null
      var image = null
      var position = ''
      if (index >= 0 && (types[index].type == type)) {
        name = profile.first_name
        address = profile.address
        phone = profile.mobile_number
        birthday = profile.birthday
        image = profile.profile_image

        if (type == 'doctor')
          position = profile.specializations.specialization[0].specialization
      }
      state.position = position
      state.name = name
      state.address = address
      state.phone = phone
      state.birthday = birthday
      state.image = image
      state.displayName = name || data.email
      state.type = data.user_type
      // state.category = types[index].category
    },
    setField(state, {name, value}) {
      state[name] = value
    },
    clearFields(state) {
      state.name = ''
      state.image = null
      state.category = ''
      state.position = ''
      state.birthday = null
      state.sss = ''
      state.philhealth = ''
      state.pagibig = ''
      state.email = ''
      state.phone = ''
      state.address = ''
      state.user = null
      state.displayName = ''
    },
    updateUsers(state, {type, data}) {
      if (type == 'add')
        state.users.push(data)
      else {
        state.users.splice(1, 0, data)
      }
    },
    deleteFromUsers(state, id) {
      var index = state.users.findIndex(user => user.id == id)
      state.users.splice(index, 1)
    }
  },

  actions: {
    /* admin page users */
    async fetchUsers(state, {page, per_page, no_patient=null, update_sort=null, tma_and_doctors_only=null}) {
      var response = await User.getUsers(page, per_page, tma_and_doctors_only);
      // temporary filter for "no patient" users only
      var users = no_patient
        ? response.data.data.filter(item => item.user_type !== 'patient')
        : response.data.data
      if (update_sort)
        users = users.sort((a,b) => {a.updated_at.valueOf() - b.updated_at.valueOf()})
      
      var pages = response.data.last_page
      state.commit('setUsers', {users, pages})
    },
    async fetchUser(state, {set_fields=null, id=null}) {
      var response = await User.get(id)
      state.commit('setCurrentUser', response.data)
      if (set_fields) state.commit('setFields', response.data)
    },
    async addUser({getters}) {
      var payload = {}

      var type = ''
      switch (getters.category) {
        case 'Doctor':
          type = 'doctor'
          payload.is_doctor = 1
          payload.specialization_id = getters.position
          break;
        case 'TMA':
          type = 'tma'
          payload.is_tma = 1
          break;
        case 'CSR':
          type = 'csr'
          payload.is_csr = 1
          break;
        case 'Admin':
          type = 'admin'
          payload.is_admin = 1
          break;
        default:
          break;
      }

      // let formData = new FormData();
      // formData.append('file', getters.image);

      payload = {
        fullname: getters.name,
        // profile_image: getters.image,
        birthday: getters.birthday,
        email: getters.email,
        username: getters.email,
        user_type: type,
        mobile_number: getters.phone,
        address: getters.address,
        sss_number: getters.sss.split('-').join(''),
        philhealth_number: getters.philhealth.split('-').join(''),
        pagibig_number: getters.pagibig.split('-').join(''),
        password: 'Medgate123!'
      }
      let response = await User.createUser(payload)
      // commit('updateUsers', {type: 'edit', data: response.data.user})
      console.log("[user/add]", response)
      return response
    },
    async editUser({getters}, id) {
      const payload = {
        first_name: getters.name,
        email: getters.email,
        mobile_number: getters.phone,
        address: getters.address,
        username: getters.email,
      }
      switch (getters.category) {
        case 'TMA':
          payload.is_tma = 1
          break;
        case 'Doctor':
          payload.is_doctor = 1
          break;
        case 'Admin':
          payload.is_admin = 1
          break;
        case 'Supervisor':
          payload.is_supervisor = 1
          break;
        default:
          // payload.is_doctor = 1
          break;
      }
      let response = await User.updateUser(id, payload);
      console.log("[user/edit]", response);
      return response;
    },
    async deleteUser({commit}, id) {
      let response = await User.deleteUser(id)
      commit('deleteFromUsers', id)
      console.log("[user/delete]", response)
      return response;
    },
    async resetUserPasswordViaEmail(context, email) {
      return await User.resetUserPasswordViaEmail(email)
        .then(response => {
          console.log({ response }, "resetUserPasswordViaEmail")
          return {
            success: true
          }
        })
        .catch(error => {
          console.log({ error }, "resetUserPasswordViaEmail")
          return {
            success: false
          }
        })
    }
  }
})